(function () {
  function eachList(root, callback) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-product-mini-list]')) {
      callback(scope);
      return;
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-product-mini-list]').forEach(callback);
    }
  }

  function isHorizontal(list) {
    return (list.dataset.productMiniListDirection || 'vertical') === 'horizontal';
  }

  function initList(list) {
    if (!list || list.dataset.productMiniListReady === 'true') return;

    var scrollArea = list.querySelector('[data-product-mini-list-scroll]');
    var hint = list.querySelector('[data-product-mini-list-hint]');
    var prev = list.querySelector('[data-product-mini-list-prev]');
    var next = list.querySelector('[data-product-mini-list-next]');

    if (!scrollArea) return;

    list.dataset.productMiniListReady = 'true';

    function getScrollAmount() {
      var card = scrollArea.querySelector('.custom-product-mini-card');
      var gap = parseFloat(window.getComputedStyle(scrollArea).gap) || 0;

      if (!card) {
        return Math.floor((isHorizontal(list) ? scrollArea.clientWidth : scrollArea.clientHeight) * 0.8);
      }

      var rect = card.getBoundingClientRect();

      if (isHorizontal(list)) {
        return Math.floor((rect.width + gap) * 2);
      }

      return Math.floor(rect.height + gap);
    }

    function updateHint() {
      if (!hint) return;

      if (isHorizontal(list)) {
        hint.hidden = true;
        hint.style.display = 'none';
        return;
      }

      var canScroll = scrollArea.scrollHeight > scrollArea.clientHeight + 1;
      var isAtBottom = scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 2;
      var shouldShow = canScroll && !isAtBottom;

      list.classList.toggle('custom-product-mini-list--has-overflow', canScroll);
      list.classList.toggle('custom-product-mini-list--is-at-bottom', isAtBottom);

      if (shouldShow) {
        hint.hidden = false;
        hint.removeAttribute('hidden');
        hint.style.setProperty('display', 'flex', 'important');
      } else {
        hint.hidden = true;
        hint.setAttribute('hidden', '');
        hint.style.setProperty('display', 'none', 'important');
      }
    }

    function updateArrows() {
      if (!prev || !next) return;

      if (!isHorizontal(list)) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      var maxScroll = scrollArea.scrollWidth - scrollArea.clientWidth;
      var hasOverflow = maxScroll > 4;

      if (!hasOverflow) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      prev.hidden = scrollArea.scrollLeft <= 4;
      next.hidden = scrollArea.scrollLeft >= maxScroll - 4;
    }

    function update() {
      updateHint();
      updateArrows();
    }

    function scheduleUpdate() {
      requestAnimationFrame(update);
      window.setTimeout(update, 80);
      window.setTimeout(update, 300);
      window.setTimeout(update, 600);
    }

    list._customProductMiniListUpdate = update;
    list._customProductMiniListScheduleUpdate = scheduleUpdate;

    scrollArea.addEventListener('scroll', update, { passive: true });

    if (prev) {
      prev.addEventListener('click', function () {
        scrollArea.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollArea.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    scrollArea.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) {
        image.addEventListener('load', scheduleUpdate, { once: true });
        image.addEventListener('error', scheduleUpdate, { once: true });
      }
    });

    window.addEventListener('resize', scheduleUpdate);
    scheduleUpdate();
  }

  function init(root) {
    eachList(root || document, initList);
  }

  function update(root) {
    eachList(root || document, function (list) {
      if (list.dataset.productMiniListReady !== 'true') {
        initList(list);
      }

      if (typeof list._customProductMiniListScheduleUpdate === 'function') {
        list._customProductMiniListScheduleUpdate();
      } else if (typeof list._customProductMiniListUpdate === 'function') {
        list._customProductMiniListUpdate();
      }
    });
  }

  function updateAllSoon() {
    update(document);
    window.setTimeout(function () {
      update(document);
    }, 120);
    window.setTimeout(function () {
      update(document);
    }, 360);
  }

  window.CustomProductMiniList = window.CustomProductMiniList || {};
  window.CustomProductMiniList.init = init;
  window.CustomProductMiniList.update = update;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('click', function () {
    requestAnimationFrame(updateAllSoon);
  });

  document.addEventListener('transitionend', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-product-mini-list]')) {
      update(event.target.closest('[data-product-mini-list]'));
    } else {
      update(document);
    }
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    update(event.target);
  });
})();
